import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import '../general/General.css';
import { useNavigate } from "react-router-dom";
import { useCheckAccess } from "../../utils/Utilities";
import ExpenseStatement from "../money/ExpenseStatement";
import { useSelector } from "react-redux";
const ExpensesAdmin = () => {
  useCheckAccess('ExpenseRO,StatementsRO');
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Donation Admin</title>
        <link rel="canonical" href="/donation" />
      </Helmet>
      <>
        {user?.roles?.includes('ExpenseRO') && (
          <div className="general_parent">
            <div className="general_container">
              <div className="general_body">
                <Breadcrumbs /><br />
                {user?.roles?.includes('ExpenseRW') && (
                  <button onClick={() => navigate("/expense/create")}>செலவு உருவாக்கு</button>
                )}
                {user?.roles?.includes('ExpenseRO') && (
                  <button onClick={() => navigate("/expense/search")}>செலவுகள் தேடல்</button>
                )}
                <br />
              </div>
            </div>
          </div>
        )}

        {
          user.roles && ['ExpenseRO', 'StatementsRO'].some(role => user.roles.includes(role))
          && (
            <div className="general_parent">
              <div className="general_container">
                <div className="general_body">
                  <ExpenseStatement />
                </div>
              </div>
            </div>
          )}
      </>
      <br />
      <Footer />
    </>
  );
};

export default ExpensesAdmin;
